module.exports = __webpack_public_path__ + "assets/img/A_icon.26b9af02.png";